import React from "react";
import { Link } from "react-router-dom";

const HeroBanner = () => {
  return (
    <React.Fragment>
      {/* Hero Start */}
      <section className="hero-section" id="home">
        <div className="container">
          <div className="row align-items-center">
            {/* Content Column */}
            <div className="col-lg-6">
              <div className="hero-content">
                {/* Trust Badge - Updated Content */}
                <div className="mb-4 pt-5">
                  <span className="badge bg-white text-primary fw-semibold px-3 py-2 rounded-pill">
                    <i className="fas fa-shield-alt me-2"></i>
                    Compliant & Regulated Infrastructure
                  </span>
                </div>

                {/* Main Heading */}
                <h1 className="display-5 fw-bold text-white mb-3">
                  Power Your Business with
                  <span className="text-warning"> Secure Financial APIs</span>
                </h1>

                {/* Subheading */}
                <p className="lead text-light mb-4">
                  India's most comprehensive suite of recharge, utility
                  payments, and compliance APIs. Build, launch, and scale your
                  financial products faster with our regulated infrastructure.
                </p>

                {/* CTA Buttons */}
                <div className="d-flex flex-wrap gap-3 mb-4">
                  {/* Updated Get Started Button - Changed to blue */}
                  <Link
                    to="https://app.formaxpay.com/partner-signup"
                    className="btn btn-success btn-lg px-4"
                    style={{ borderColor: "#4a6cf7" }}
                  >
                    Create API Partner Account
                    <i className="fas fa-arrow-right ms-2"></i>
                  </Link>

                  {/* API Documentation Button with white text */}
                  <a
                    href="https://developers.formaxpay.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-light btn-lg px-4"
                    style={{
                      color: "white",
                      border: "2px solid orange",
                      background: "transparent",
                    }}
                  >
                    <i className="fas fa-book me-2"></i>
                    API Documentation
                  </a>
                </div>

                {/* Popular APIs Section */}
                <div className="popular-apis mb-4">
                  <p className="text-light opacity-75 mb-2">Popular APIs:</p>
                  <div className="d-flex flex-wrap gap-2">
                    <a
                      href="/recharge-and-bill-payment"
                      className="btn btn-sm btn-outline-light px-3 text-white"
                    >
                      <i className="fas fa-mobile-alt me-1"></i> Recharge API
                    </a>
                    <a
                      href="/pan-card-services"
                      className="btn btn-sm btn-outline-light px-3 text-white"
                    >
                      <i className="fas fa-id-card me-1"></i> PAN Card API
                    </a>
                    <a
                      href="/insurance-posp"
                      className="btn btn-sm btn-outline-light px-3 text-white"
                    >
                      <i className="fas fa-file-invoice me-1"></i> Insurance
                      POSP API
                    </a>
                  </div>
                </div>

                {/* Features */}
                <div className="features mb-4">
                  <div className="d-flex flex-wrap gap-2 mb-3">
                    <span className="feature-badge">
                      <i className="fas fa-bolt text-warning me-1"></i>
                      Real-time Processing
                    </span>
                    <span className="feature-badge">
                      <i className="fas fa-lock text-warning me-1"></i>
                      Bank-Grade Security
                    </span>
                    <span className="feature-badge">
                      <i className="fas fa-chart-line text-warning me-1"></i>
                      99.9% Uptime
                    </span>
                  </div>
                </div>

                {/* Statistics - Updated with new metric */}
                <div className="stats-section">
                  <p className="text-light opacity-75 mb-2">
                    Trusted by leading businesses
                  </p>
                  <div className="d-flex flex-wrap gap-4">
                    <div className="stat-item">
                      <h3 className="text-white mb-1">20+</h3>
                      <p className="text-light opacity-75 mb-0">APIs</p>
                    </div>
                    <div className="stat-item">
                      <h3 className="text-white mb-1">24/7</h3>
                      <p className="text-light opacity-75 mb-0">Support</p>
                    </div>
                    <div className="stat-item">
                      <h3 className="text-white mb-1">500+</h3>
                      <p className="text-light opacity-75 mb-0">Businesses</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Dashboard Image Column */}
            <div className="col-lg-6 mt-4 mt-lg-0">
              <div className="dashboard-image">
                <img
                  src="/images/dash_2.png"
                  alt="Formax Pay Dashboard"
                  className="img-fluid rounded shadow-lg"
                />
                {/* Simple overlay for API docs */}
                {/* <div className="api-docs-card">
                  <div className="card border-0 shadow-sm">
                    <div className="card-body p-3">
                      <div className="d-flex align-items-center">
                        <div className="bg-primary bg-opacity-10 p-2 rounded me-3">
                          <i className="fas fa-code text-primary"></i>
                        </div>
                        <div>
                          <h6 className="mb-0">API Documentation</h6>
                          <small className="text-muted">
                            developers.formaxpay.com
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Styles */}
      <style jsx>{`
        .hero-section {
          padding: 100px 0;
          background: linear-gradient(135deg, #4a6cf7 0%, #3a56d4 100%);
          position: relative;
          overflow: hidden;
        }

        .hero-section::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.03' fill-rule='evenodd'/%3E%3C/svg%3E");
          opacity: 0.5;
        }

        .hero-content {
          position: relative;
          z-index: 1;
        }

        .display-5 {
          font-size: 2.5rem;
          line-height: 1.2;
        }

        .lead {
          font-size: 1.1rem;
          opacity: 0.9;
        }

        .feature-badge {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          padding: 6px 12px;
          font-size: 0.85rem;
          color: white;
          display: inline-flex;
          align-items: center;
        }

        .btn-primary {
          background: #ffc107;
          border: none;
          color: #212529;
          font-weight: 600;
          transition: all 0.3s ease;
        }

        .btn-primary:hover {
          background: #e0a800;
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(255, 193, 7, 0.3);
        }

        .btn-outline-light:hover {
          background: rgba(255, 255, 255, 0.1);
        }

        .stats-section .stat-item {
          text-align: center;
        }

        .stats-section h3 {
          font-size: 2rem;
        }

        .dashboard-image {
          position: relative;
        }

        .api-docs-card {
          position: absolute;
          top: -15px;
          right: 20px;
          width: 260px;
          animation: float 3s ease-in-out infinite;
        }

        @keyframes float {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-5px);
          }
        }

        @media (max-width: 992px) {
          .hero-section {
            padding: 80px 0;
          }

          .display-5 {
            font-size: 2rem;
          }

          .api-docs-card {
            position: relative;
            top: auto;
            right: auto;
            margin: 20px auto 0;
            animation: none;
          }

          .dashboard-image {
            margin-top: 30px;
          }
        }

        @media (max-width: 768px) {
          .hero-section {
            padding: 60px 0;
          }

          .display-5 {
            font-size: 1.8rem;
          }

          .lead {
            font-size: 1rem;
          }

          .btn-lg {
            padding: 0.75rem 1.5rem;
            font-size: 1rem;
          }
        }
        .btn-outline-light:hover {
          background: rgba(255, 255, 255, 0.1);
          color: white !important;
        }

        .popular-apis .btn-outline-light {
          font-size: 0.85rem;
          padding: 0.25rem 0.75rem;
        }

        .feature-badge {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          border-radius: 20px;
          padding: 6px 12px;
          font-size: 0.85rem;
          color: white;
          display: inline-flex;
          align-items: center;
        }

        .stat-item {
          text-align: center;
        }

        .stat-item h3 {
          font-size: 2rem;
        }

        @media (max-width: 768px) {
          .stat-item h3 {
            font-size: 1.5rem;
          }

          .popular-apis .btn-outline-light {
            font-size: 0.75rem;
            padding: 0.2rem 0.5rem;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default HeroBanner;
